// extracted by mini-css-extract-plugin
export default {"singleResultContainer":"MpsWAQtRU5eZGjtYR4e3"};